import type { RouteObject } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import Home from "@/pages/home/page";
import Category from "@/pages/category/page";
import NewsDetail from "@/pages/detail/news/page";
import RecommendDetail from "@/pages/detail/recommend/page";
import CharacterDetail from "@/pages/detail/character/page";
import SearchPage from "@/pages/search/page";
import About from "@/pages/about/page";
import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: "category/:type", element: <Category /> },
      { path: "detail/news/:id", element: <NewsDetail /> },
      { path: "detail/recommend/:id", element: <RecommendDetail /> },
      { path: "detail/character/:id", element: <CharacterDetail /> },
      { path: "search", element: <SearchPage /> },
      { path: "about", element: <About /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;